import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {DevTools, FormatSimple, Tolgee, TolgeeProvider, TranslatePropsInternal} from "@tolgee/react";

import localeDe from './i18n/de.json';
import localeEn from './i18n/en.json';
import {getDebug, getLang} from "./Data";

export const missingKeys = new Map<string, Map<string, string>>();

export const devMode = (document.location.hostname === "localhost" || document.location.hostname === "127.0.0.1" || getDebug());
export const testMode = false;

const tolgee = Tolgee()
    .use(devMode ? DevTools() : undefined)
    .use(FormatSimple())
    .init({
        language: getLang(),
        availableLanguages: ['en', 'de'],
        ...(devMode ?
            {
                apiUrl: process.env.REACT_APP_TOLGEE_API_URL,
                apiKey: process.env.REACT_APP_TOLGEE_API_KEY,
                onTranslationMissing: function (info: TranslatePropsInternal) {
                    const language = tolgee.getLanguage() ?? "none";
                    let missingKeysForLanguage = missingKeys.get(language);

                    if (!missingKeysForLanguage) {
                        missingKeysForLanguage = new Map<string, string>();
                        missingKeys.set(language, missingKeysForLanguage);
                    }

                    let missingKey = missingKeysForLanguage.get(info.key);
                    if (!missingKey) {
                        const variables = "[" + (info.params ? Object.keys(info.params).map(key => "{" + key + "}").join() : "") + "]";
                        if (info.defaultValue) {
                            missingKeysForLanguage.set(info.key, info.defaultValue + variables );
                        } else {
                            missingKeysForLanguage.set(info.key, variables);
                        }
                    }

                    return info.key;
                }
            } :
            {
                staticData: {
                    en: localeEn,
                    de: localeDe
                }

            })

    });

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <TolgeeProvider
            tolgee={tolgee}
            fallback="Loading..." // loading fallback
        >
            <App/>
        </TolgeeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
